export enum OpenOrdersType {
  ALL = 'all',
  LAYAWAYS = 'layaways',
  SPECIAL_ORDERS = 'specialOrders',
  WORK_ORDERS = 'workOrders',
}
